import React, {useState, useEffect, useRef } from 'react';
import Sidebar from './Sidebar'; 
import MainMenu from './MainMenu'; 
import InsightNoteSidebar from './insight_note/InsightNoteSidebar';  
import InsightNoteContainer from './insight_note/InsightNoteContainer';  
import SidebarDisplayButton from './SidebarDisplayButton';
import ConfirmDialog from './utils/ConfirmDialog';
import api from './api/api';            
import { useNavigate,useLocation } from 'react-router-dom';
import { saveAccessLog } from './utils/commonUtils';
import Loading from './Loading';


function InsightNote() {
    const navigate = useNavigate();
    const location = useLocation();
    const [showMenu, setShowMenu] = useState(false); 
        
    const [selectedNoteId, setSelectedNoteId] = useState(null);
    const [showSidebar, setShowSidebar] = useState(true);
    const [showDeleteOkDialog, setShowDeleteOkDialog] = useState(false);
    const [deleteNote, setDeleteNote] = useState(null);
    const [noteList, setNoteList] = useState(null);
    const sidebarRef = useRef(null);
    const noteSidebarRef = useRef(null);
    const mainMenuRef = useRef(null); 
    
    const handleOutsideClick = (event) => {
        if (
            (sidebarRef.current && sidebarRef.current.contains(event.target)) ||
            (noteSidebarRef.current && noteSidebarRef.current.contains(event.target)) ||
            (mainMenuRef.current && mainMenuRef.current.contains(event.target)) // ← MainMenu クリックを除外
        ) {
            return;
        }
        setShowMenu(false);
    };

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
        };
    }, []);
    
    const fetchInsightNoteList = async () => {
        try {
            const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/insight-note-list/`);
            setNoteList(response.data); // データを state にセット
            if (response.data.length > 0) {
                handleNoteSelect(response.data[0].id); // 最初のノートを自動選択
            }
        } catch (error) {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                // navigate('/login', { state: { from: location.pathname } });
            } else {
                console.error('Error fetching insight note list:', error);
            }
        }
    };

    const handleNoteSelect = (noteId) => {
        if (noteId) {
            setSelectedNoteId(noteId);
        } else {
            setSelectedNoteId('');
        }
        setShowMenu(false);
    };

    const closeSidebarClick = () => {
        setShowSidebar(false);
    }

    const displaySidebarClick = () => {
        setShowSidebar(true);
    }

    const onDeleteButtonClick = (noteId, noteTitle) => {
        setDeleteNote({id: noteId, noteTitle: noteTitle});
        setShowDeleteOkDialog(true);
    }

    const onDeleteOkClick = async () => {
        try {
            const noteId = deleteNote.id;
            // DELETEリクエストを送信
            const response = await api.delete(`chat/api/insight-note/${noteId}/`);

            if (response.status === 200) {
                await fetchInsightNoteList(); // ノートリストをリフレッシュ
            } else {
                console.error("Failed to delete note");
            }
            setShowDeleteOkDialog(false);
        } catch (error) {
            console.error("Error deleting note:", error);
        }
    };

    const onCancelClick = () => {
        setShowDeleteOkDialog(false);
    }

    useEffect(() => {
        fetchInsightNoteList(); // コンポーネントの初回読み込み時にノートリストを取得
        saveAccessLog('insight note page')
    }, []);

    const mainMenuClick = () => {
        setShowMenu(!showMenu)
    }

    return (
        <>
            <MainMenu ref={mainMenuRef} handleClick={mainMenuClick} />
            <div className="main-container">
                <div ref={sidebarRef}>
                    <Sidebar selectedIcon="insight-note" showMenu={showMenu} />
                </div>
                <>
                    {showSidebar ? 
                        <InsightNoteSidebar 
                            ref={noteSidebarRef} 
                            noteList={noteList} 
                            onNoteSelect={handleNoteSelect} 
                            selectedNoteId={selectedNoteId} 
                            closeSidebarClick={closeSidebarClick} 
                            onDeleteButtonClick={onDeleteButtonClick} 
                            showMenu={showMenu}/> 
                        : 
                        <SidebarDisplayButton displaySidebarClick={displaySidebarClick} color="white" />
                    }
                    {showDeleteOkDialog && <ConfirmDialog message={`「${deleteNote.noteTitle}」を削除してもよいですか？`} onOkClick={onDeleteOkClick} onCancelClick={onCancelClick} />}
                    <InsightNoteContainer noteId={selectedNoteId} key={selectedNoteId} expandMargin={!showSidebar}/>
                </>
            </div>      
            
        </>
    );
}

export default InsightNote;
